/*  NailHandy — điều phối trượt tự động cho các băng thẻ.
 *
 *  Ba nguyên tắc:
 *  1. Trượt TỪNG THẺ một, glide chậm — không nhảy cả trang.
 *  2. Chỉ MỘT băng chạy tại một thời điểm: băng nào lộ ra nhiều nhất thì chạy,
 *     các băng còn lại đứng yên. Nhờ vậy trang không bị loạn dù có 7 băng.
 *  3. Khách chạm vào là dừng: rê chuột, bấm mũi tên, kéo tay, hoặc bật
 *     "giảm chuyển động" trong hệ điều hành.
 */
(function () {
  'use strict';

  var GLIDE_MS = 900;          // độ dài một cú trượt — đủ chậm để mắt bám theo
  var MIN_VISIBLE = 0.35;      // băng phải lộ ra >=35% mới được phép chạy
  var SEL = 'splide-component[data-autoplay="true"]';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ratios = new WeakMap();  // phần tử -> tỉ lệ lộ ra
  var frozen = new WeakMap();  // phần tử -> khách đã can thiệp, thôi tự chạy
  var known = [];

  function autoplayOf(el) {
    return el.splide && el.splide.Components && el.splide.Components.Autoplay;
  }

  /* Chọn đúng một băng để chạy: băng lộ ra nhiều nhất và chưa bị đóng băng. */
  function rebalance() {
    var winner = null;
    var best = MIN_VISIBLE;
    // Tab đang ở nền thì không băng nào được chạy (kể cả lúc mới tải).
    if (document.hidden) {
      known.forEach(function (el) { var a = autoplayOf(el); if (a) a.pause(); });
      return;
    }
    known.forEach(function (el) {
      if (frozen.get(el)) return;
      var r = ratios.get(el) || 0;
      if (r >= best) { best = r; winner = el; }
    });
    known.forEach(function (el) {
      var ap = autoplayOf(el);
      if (!ap) return;
      if (el === winner && !reduced.matches) ap.play();
      else ap.pause();
    });
  }

  function freeze(el) {
    frozen.set(el, true);
    var ap = autoplayOf(el);
    if (ap) ap.pause();
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
        rebalance();
      }, { threshold: [0, 0.15, 0.35, 0.6, 0.85, 1] })
    : null;

  /* Số thẻ không nhiều hơn số cột => không có gì để trượt.
     Bỏ qua hẳn, nếu không nó vẫn tranh lượt và chặn băng thật sự cần chạy. */
  function nothingToScroll(sp) {
    var perPage = sp.options.perPage || 1;
    return sp.length <= perPage;
  }

  function adopt(el) {
    if (!el.splide || known.indexOf(el) !== -1) return;
    if (nothingToScroll(el.splide)) {
      var ap0 = autoplayOf(el);
      if (ap0) ap0.pause();
      return;
    }

    // Trượt chậm hẳn lại. Splide mặc định 400ms — nhanh như cái giật.
    el.splide.options = {
      speed: GLIDE_MS,
      easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
      pauseOnHover: true,
      pauseOnFocus: true
    };

    // Khách bấm mũi tên hoặc kéo tay = khách đang tự lái. Thôi tự chạy.
    el.splide.on('arrows:updated', function () {});
    el.addEventListener('click', function (ev) {
      if (ev.target.closest('.splide__arrow')) freeze(el);
    }, true);
    el.splide.on('drag', function () { freeze(el); });

    known.push(el);
    if (observer) observer.observe(el);
    else ratios.set(el, 1);
    rebalance();
  }

  function scan() {
    document.querySelectorAll(SEL).forEach(adopt);
  }

  /* splide-component tự dựng trong connectedCallback, có thể xong sau script này. */
  function boot() {
    scan();
    // quét lại vài nhịp để bắt các băng mount muộn (ảnh lazy, section load lại)
    var tries = 0;
    var t = setInterval(function () {
      scan();
      if (++tries >= 10) clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    known = known.filter(function (el) { return el.isConnected; });
    setTimeout(scan, 100);
  });

  // Đổi cài đặt giảm chuyển động giữa chừng thì tôn trọng ngay.
  if (reduced.addEventListener) reduced.addEventListener('change', rebalance);

  // Rời tab thì dừng hẳn, quay lại mới chạy tiếp — đỡ tốn pin, đỡ giật khi quay về.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) known.forEach(function (el) {
      var ap = autoplayOf(el); if (ap) ap.pause();
    });
    else rebalance();
  });
})();
